<template>
    <div class="complex" ref="BigMain">
        <navigation-bar Back Bell SearchPop
                        :icon="pageData.imgUrl"
                        :searchText="pageData.searchText"
                        :textOnSearchEmpty="pageData.defaultSearchText"
                        @searchWord="onKeywordEnter"/>

        <div class="main" ref="main">
            <!--todo 第一層分類icon-->
            <quick-menu :list="pageData.typeList" class="mb-2" :defIcon="getFilterBtnName()" @clickItem="onQuickMenuClick"/>

            <!--todo 搶券熱區-->
            <item-grid class="two-gird coupon-list" v-show="pageData.tabType === pageData.tabTypeAry[0]">
<!--                <ticket-item :list="pageData.couponList"/>-->
                <ticket-item :list="pageData.ticketList"/>
            </item-grid>

            <!--todo 外帶外送＋線上點餐共用-->
            <div v-show="pageData.tabType === pageData.tabTypeAry[1]" class="mt-2 mb-2 pb-5">
                <article-cover :list="pageData.storeTakeoutList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" :actionType="'OrderList'" hideStar/>
            </div>

            <div v-show="pageData.tabType === pageData.tabTypeAry[2]" class="mt-2 mb-2 pb-5">
                <article-cover :list="pageData.storeBookingList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" :actionType="'Booking'" hideStar/>
            </div>

            <!--todo 商圈夜市-->
            <div class="container marketplace-list" v-show="pageData.tabType === pageData.tabTypeAry[3]">
                <marketplace-item :list="pageData.shoppingAreaList"/>
            </div>

            <!--todo 主題活動-->
            <activity-item :list="pageData.activityList" v-show="pageData.tabType === pageData.tabTypeAry[4]"/>

            <infinite-loading v-if="pageData.isSetupData" @infinite="setupDataScroll" :identifier="pageData.infiniteLoadingTrigger" ref="infiniteLoading" spinner="waveDots">
              <div slot="no-more">已沒有更多資料</div>
              <span slot="no-results">已沒有更多資料</span>
            </infinite-loading>
        </div>
        <loading
            :active.sync=pageData.isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    import MarketplaceItem from './components/MarketplaceItem';
    import QuickMenu from '@/components/QuickMenu';
    // import QuickMenu from '@/components/QuickMenuComplex';
    import TicketItem from "../home/components/TicketItem";
    import ArticleCover from '@/components/article/ArticleCover'
    import ActivityItem from '../activity/components/ActivityItem'
    import ItemGrid from '@/components/category/ItemGrid.vue'
    import * as mutationTypes from '@/store/mutationTypes'
    import Toast from "@/components/Toast"
    import * as constDefine from '@/store/constDefine'


    export default {
        name: "Complex",
        components: {
            Toast,
            MarketplaceItem,
            QuickMenu,
            TicketItem,
            ActivityItem,
            ArticleCover,
            ItemGrid,
        },
        data() {
            return {
                pageData: {
                    isLoading: false,
                    isSetupData: false,

                    //上次搜尋的關鍵字
                    lastSearch: '商圈夜市',
                    //搜尋的分類icon
                    imgUrl: require('@/assets/images/quickMenu/market.svg'),

                    //第一層分類, type 的種類list
                    typeList: [],

                    lng: 0,
                    lat: 0,
                    pageSize: 10,
                    currentPage: 0,
                    tabPageAry: [],
                    tabListAry: [],
                    //店家列表
                    storeBookingList: [],    //訂候位分頁的列表
                    storeTakeoutList: [],    //外帶外送分頁的列表
                    storeList: [],          //外帶外送 & 訂位用店家資料
                    couponList: [],         //優惠券資料
                    ticketList: [],         //搶券資料
                    shoppingAreaList: [],   //商圈資料
                    activityList: [],       //主題活動資料
                    tabTypeAry: [constDefine.TAB_ID_COUPON,
                        constDefine.TAB_ID_TAKEOUT,
                        constDefine.TAB_ID_BOOKING,
                        constDefine.TAB_ID_MARKET,
                        constDefine.TAB_ID_ACTIVITY,
                        constDefine.TAB_ID_STORE,],        //<template> 裡面無法使用其他地方定義的常數，所以把常數填入陣列中代替
                    tabType: Number(constDefine.TAB_ID_COUPON),     //目前顯示的 tab的 id
                    currentTab: 0,          //目前所在 tab
                    activeTabName: '',      //目前點選的 tab名稱
                    searchText: '',         //搜尋用關鍵字
                    defaultSearchText: '',  //搜尋關鍵字爲空白時，搜尋框預設會出現的文字
                    filterTab: null,        //點選到的第一層分類
                    scrollTo: '',           //列表捲動的位置
                    offsetHeight: 0,        //列表的高度
                    setupListData: false,
                    infiniteLoadingTrigger: 0,
                    infiniteLoadingState: '',
                }
            }
        },
        computed: {},
        created() {
            if(this.$refs.InfiniteLoading){
                this.$refs.InfiniteLoading.stateChanger.reset();
            }
        },
        mounted() {

            //搶券、商圈、主題活動、外帶外送(店家)、訂候位(店家)、

            //Promise內是非同步執行
            //如果 then裡面是用函式形態包起來的話，函式內也會變成非同步執行
            //若 then裡面是函式形態，但還要接 Promise的話，要以 return回傳 Promise物件，才會等待 Promise的回傳
            //沒有 return的話， then不會等待 Promise的回覆，直接往下進行

            this.pageData.tabType = Number(this.$route.query.showType);

            this.init();

            //讀取資料，沒有資料的話就重抓
            if ( this.hasSnapshot() ) {
                this.restoreFromSnapshot();

                //讀完以後刪除
                this.saveToSnapshot('delete');
                //把分頁設指向預設的頁
                this.pageData.filterTab = this.getStoreTypeById(this.pageData.tabType);

            } else {

                let self = this;
                // self.isLoading = true;

                self.getGpsLocation()
                    .then(
                        self.getStoreTypeList
                    )
                    .then(
                        () => {
                            //把分頁設指向預設的頁
                            self.pageData.filterTab = self.getStoreTypeById(self.pageData.tabType);
                            //改變搜尋框預設的關鍵字
                            self.pageData.defaultSearchText = self.pageData.filterTab.name;

                            return self.handLoading();
                        }
                    )
                    .catch( (error) => {
                        self.handLoading();
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            }

            window.onresize = () => {
                //電腦版打橫時，載入更多reset
                if (this.$refs.infiniteLoading) {
                    this.$refs.infiniteLoading.stateChanger.reset();
                }
            }

        },
        updated: function (params) {
            // 渲染完成後等一下才捲到目標位置
            setTimeout(() => {
                //回復店家列表捲動狀態
                this.restoreScroll();
            }, 100);
        },
        beforeRouteLeave: function(to, from, next) {
            // 如果不是返回上一頁的話就記住快照
            if ( from.name === 'Complex' &&
                ['Home'].indexOf(to.name) === -1) {
                this.updateScrollValue();
                this.saveToSnapshot(this.pageData);
            }
            next();

        },
        methods: {

            /** 取得目前點到的分類按鈕的名稱 */
            getFilterBtnName: function() {
                return (this.pageData.filterTab===null || this.pageData.filterTab===undefined)?'':this.pageData.filterTab.name;
            },

            /** 更新店家列表捲動狀態數值 */
            updateScrollValue: function() {
                let pData = this.pageData;
                //手機版紀錄捲動位置
                let object = this.$refs.main

                //網頁版紀錄捲動位置
                const fullWidth = window.innerWidth;
                if(fullWidth>=1024){
                    object = this.$refs.BigMain
                }

                if (this.$public.notNull(object)) {
                    pData.scrollTo = object.scrollTop;
                    pData.offsetHeight = object.offsetHeight;
                }
            },

            /** 回復店家列表捲動狀態 */
            restoreScroll: function() {
                let pData = this.pageData;
                if (this.$public.notNull(pData.scrollTo) && pData.scrollTo !== '') {
                    //手機版紀錄捲動位置
                    let object = this.$refs.main

                    //網頁版紀錄捲動位置
                    const fullWidth = window.innerWidth;
                    if(fullWidth>=1024){
                        object = this.$refs.BigMain
                    }

                    if (this.$public.notNull(object)) {
                        if (pData.offsetHeight === object.offsetHeight) {
                            object.scrollTo(0, pData.scrollTo);
                        }
                    }
                    pData.scrollTo = '';
                }
            },
            /** 將pageData存到暫存中 */
            saveToSnapshot(data) {
                this.$store.commit("saveComplexPageSnapshot", data);
            },

            /** 是否有暫存 */
            hasSnapshot: function() {
                return this.$public.notNull(this.$store.state?.complexPageSnapshot?.lng);
            },

            /** 將暫存的資料回存 */
            restoreFromSnapshot() {
                if ( this.$public.notNull(this.$store.state?.complexPageSnapshot?.lng)) {
                    this.pageData = this.$store.state?.complexPageSnapshot;
                }

            },

            /** 初始化 */
            init() {
                let pData = this.pageData;
                //
                if (pData.infiniteLoadingState !== '') {
                    pData.infiniteLoadingState?.complete();
                }

                //店家列表
                pData.storeBookingList = [];    //訂候位分頁的列表
                pData.storeTakeoutList = [];    //外帶外送分頁的列表
                pData.shoppingAreaList = [];        //商圈資料
                pData.activityList = [];
                pData.couponList = [];  //優惠券資料
                pData.ticketList = [];  //搶券資料

                pData.currentPage = 0;
                pData.setupListData = false;

                pData.storeList = [];

                // if (this.$refs.infiniteLoading) {
                //     // console.log(`reset infiniteLoading`);
                //     this.$refs.infiniteLoading.stateChanger.reset();
                // }
            },


            /** tab 重置 */
            tabReset: function (tabIndex) {
                let pData = this.pageData;
                // if (tabIndex < pData.tabPageAry.length) {
                //     pData.tabPageAry[tabIndex] = 0;
                // }
                // if (tabIndex < pData.tabListAry.length) {
                //     pData.tabListAry[tabIndex] = [];
                // }

                switch (pData.tabType) {
                    case pData.tabTypeAry[0]:
                        pData.couponList = [];
                        pData.ticketList = [];
                        break;
                    case pData.tabTypeAry[1]:
                        pData.storeTakeoutList = [];
                        break;
                    case pData.tabTypeAry[2]:
                        pData.storeBookingList = [];
                        break;
                    case pData.tabTypeAry[3]:
                        pData.shoppingAreaList = [];
                        break;
                    case pData.tabTypeAry[4]:
                        pData.activityList = [];
                        break;
                }

                // 筆記：只清掉自己頁面的陣列是無法切換頁面和重整的
                // tabType雖然會變，但是元件的 v-show不會即時切換，要等到該元件的陣列有變動，才會觸發 v-show判斷
                pData.currentPage = 0;
            },


            /** 手動 資料載入 */
            handLoading: function() {
                // this.init();
                let self = this;
                self.isLoading = true;
                if(this.pageData.isSetupData) {
                  self.triggerLoading();
                } else {
                  self.pageData.isSetupData = true;
                }

            },

            /** 觸發型資料載入 */
            triggerLoading: function() {
                let selfPage = this.pageData;
                let self = this;
                selfPage.isLoading = false;

                setTimeout(function(){
                    // 判斷是否已初始化過？
                    if (!selfPage.setupListData) {
                        selfPage.setupListData = true;
                        if (selfPage.infiniteLoadingState !==  '') {
                            selfPage.infiniteLoadingState?.reset();
                        }
                    }

                    // identifier設定爲監聽 infiniteLoadingTrigger
                    // 改變 infiniteLoadingTrigger，並且畫面已經捲到底，才能讓 infinite-loading觸發載入事件
                    selfPage.infiniteLoadingTrigger += 1;
                },100)
            },

            /** 下拉載入更多 */
            setupDataScroll: function ($state) {
                let pData = this.pageData;
                pData.infiniteLoadingState = $state
                pData.isLoading = true;

                let self = this;

                switch (pData.tabType) {
                    case constDefine.TAB_ID_COUPON : {
                        //搶券
                        // self.getCouponList($state)
                        self.getSeizeTicketList($state)
                            .then(() => {
                                pData.isLoading = false;
                            })
                            .catch((error) => {
                                pData.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                    }
                        break;
                    case constDefine.TAB_ID_MARKET: {
                        //商圈
                        self.getShoppingAreaListWithState($state)
                            .then(() => {
                                pData.isLoading = false;
                            })
                            .catch((error) => {
                                pData.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                        // pData.isLoading = false;
                        // pData.infiniteLoadingState?.complete();
                    }
                        break;
                    case constDefine.TAB_ID_ACTIVITY: {
                        //主題活動
                        self.getActivityList($state)
                            .then(() => {
                                pData.isLoading = false;
                            })
                            .catch((error) => {
                                pData.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                    }
                        break;
                    case constDefine.TAB_ID_TAKEOUT: {
                        //可外帶外送餐廳
                        self.getExtensionStoreListWithState($state)
                            .then(() => {
                                pData.isLoading = false;
                            })
                            .catch((error) => {
                                pData.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                    }
                        break;
                    case constDefine.TAB_ID_BOOKING: {
                        //可訂位餐廳
                        self.getExtensionStoreListWithState($state)
                            .then(() => {
                                pData.isLoading = false;
                            })
                            .catch((error) => {
                                pData.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                    }
                        break;
                    case constDefine.TAB_ID_STORE: {
                        //一般餐廳
                        self.getStoreListWithState($state)
                            .then(() => {
                                pData.isLoading = false;
                            })
                            .catch((error) => {
                                pData.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                    }
                        break;
                }
            },

            simulateQuickMenuClick: function(tabIndex) {

            },

            /** 過濾按鈕點擊 */
            onQuickMenuClick: function(clickItem) {

                //如果點到已點選的 tab，就會恢復成未選擇的狀態(filterTab = null)
                let pData = this.pageData;
                if (this.$public.notNull(clickItem)) {
                    if (this.$public.notNull(pData.filterTab)) {
                        if (pData.filterTab.name !== clickItem.name) {
                            pData.filterTab = clickItem;
                            //改變搜尋框預設的關鍵字
                            pData.defaultSearchText = pData.filterTab.name;
                            //重設資料的頁數
                            pData.currentPage = 0;
                        } else {
                            // pData.filterTab = null;
                        }
                    } else {
                        pData.filterTab = clickItem;
                    }
                } else {
                    // pData.filterTab = clickItem;
                }

                if(this.$public.notNull(pData.filterTab)){
                    //決定目前在第幾個 tab
                    for (let index = 0; index < pData.tabTypeAry.length; index++) {
                        if ( pData.filterTab.id === pData.tabTypeAry[index] ) {
                            pData.currentTab = index;
                            break;
                        }
                    }

                    //換頁前要先清掉自己這頁的東西
                    this.tabReset(pData.currentTab);

                    //換頁
                    pData.tabType = pData.filterTab.id;

                    // this.init();
                    this.tabReset(pData.currentTab);
                    this.handLoading();
                }

            },

            /** 取得GPS位置 */
            getGpsLocation: function () {
                let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        pData.lng = position.coords.longitude;
                        pData.lat = position.coords.latitude;
                        //完畢
                        resolve();
                    };

                    let onError = function (error) {
                        // reject("無法定位GPS");
                        //完畢
                        resolve();
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },

            /**
             * 取得店家分類清單
             * */
            getStoreTypeList: function () {
                let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    // self.$http.fetch`StoreTypeList${{
                    //     storeTypeId: tagByTypeId,
                    // }} ${json => {
                    //     if (json.status) {
                    //         if (self.$public.notNull(json.data)) {
                    //             pData.typeList = json.data;
                    //         }
                    //
                    //         //完成
                    //         resolve();
                    //
                    //     } else {
                    //         //失敗
                    //         reject('取得店家分類失敗');
                    //     }
                    // }}`;

                    let data = [
                        {"icon": require("@/assets/images/quickMenu/coupon.svg"),
                            "id": constDefine.TAB_ID_COUPON, "name":"搶券熱區",
                            "selectIcon": require("@/assets/images/quickMenu/coupon.svg")},
                        {"icon": require("@/assets/images/quickMenu/takeout.svg"),
                            "id": constDefine.TAB_ID_TAKEOUT, "name":"外帶外送",
                            "selectIcon": require("@/assets/images/quickMenu/takeout.svg")},
                        {"icon": require("@/assets/images/quickMenu/booking.svg"),
                            "id": constDefine.TAB_ID_BOOKING, "name":"線上訂位",
                            "selectIcon": require("@/assets/images/quickMenu/booking.svg")},
                        {"icon": require("@/assets/images/quickMenu/market.svg"),
                            "id": constDefine.TAB_ID_MARKET, "name":"商圈夜市",
                            "selectIcon": require("@/assets/images/quickMenu/market.svg")},
                        {"icon": require("@/assets/images/quickMenu/activity.svg"),
                            "id": constDefine.TAB_ID_ACTIVITY, "name":"主題活動",
                            "selectIcon": require("@/assets/images/quickMenu/activity.svg")}
                    ];

                    pData.typeList = data;

                    //完成
                    resolve();

                });
            },

            /** 優惠卷清單*/
            getCouponList: function ($state){
                let pData = this.pageData;
                let self = this;
                self.infiniteLoadingState = $state;

                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetCouponList${{
                        isShowHome: 1,
                        showArea: 0,
                        searchText: pData.searchText,
                    }} ${ json => {
                        if (self.$public.notNull(json)) {
                            if (self.$public.notNull(json.data)) {
                                pData.couponList = json.data;
                                // self.infiniteLoadingState?.loaded();     //元件會出現 no-more 的內容
                                self.infiniteLoadingState?.complete();   //元件會出現 no-result 的內容
                            }

                            resolve();

                        } else {
                            self.infiniteLoadingState?.complete();
                            //失敗
                            reject('失敗');
                        }

                    }}`;
                });
            },

            /** 搶券清單*/
            getSeizeTicketList: function ($state){
              let pData = this.pageData;
              let self = this;
              self.infiniteLoadingState = $state;

              return new Promise(function(resolve, reject) {
                self.$http.fetch`GetSeizeTicketList${{
                  offset: pData.currentPage,
                  pageSize: pData.pageSize,
                  searchText: pData.searchText,
                }} ${ json => {
                    if(json.status) {
                      pData.currentPage++;
                      pData.ticketList.tmz_load_push(...json.data);
                      if (json.data.length >= pData.pageSize) {
                        self.infiniteLoadingState?.loaded();

                      } else {
                        self.infiniteLoadingState?.complete();
                      }

                      //完成
                      resolve();

                    } else {
                      self.infiniteLoadingState?.complete();
                      //失敗
                      reject('失敗');
                    }
                }}`;
              });
            },

            /** 主題活動列表 */
            getActivityList: function ($state){
                let pData = this.pageData;
                let self = this;
                self.infiniteLoadingState = $state;

                return new Promise(function(resolve, reject) {
                    //主題活動列表
                    self.$http.fetch`GetOinActivityList${{
                        searchText: pData.searchText,
                    }} ${ json => {

                        if (self.$public.notNull(json)) {
                            pData.activityList = json;
                            self.infiniteLoadingState?.complete();
                        }

                        resolve();
                    }}`;
                });
            },

            /** 取得熱門推薦(品牌)列表 */
            getBrandListWithState: function ($state) {
                let pData = this.pageData;
                let self = this;
                self.infiniteLoadingState = $state;

                return new Promise(function(resolve, reject) {
                    self.$http.fetch`BrandList${{
                        searchType: 1,        // 0: 熱門品牌,  其他: 取得所有品牌
                    }} ${json => {
                        if (self.$public.notNull(json)) {
                            if (self.$public.notNull(json.data)) {
                                //熱門推薦只顯示20筆
                                pData.brandList.tmz_load_push(...json.data);
                                self.infiniteLoadingState?.complete();
                            }

                            //完成
                            resolve();

                        } else {
                            self.infiniteLoadingState?.complete();
                            //失敗
                            reject('失敗');
                        }
                    }}`;
                });
            },

            /** 取得商圈夜市列表 */
            getShoppingAreaListWithState: function ($state) {
                let pData = this.pageData;
                let self = this;
                self.infiniteLoadingState = $state;

                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetShoppingAreaList${{
                        offset: pData.currentPage,
                        lng: pData.lng,
                        lat: pData.lat,
                        searchText: pData.searchText,
                        // storeTypeId: (self.filterTab === null)? undefined: self.filterTab.id,
                        // subStoreTypeId: (self.filterTag === null)? undefined: self.filterTag.id,
                    }} ${json => {

                        if (self.$public.notNull(json.data)) {
                            pData.currentPage++;
                            pData.shoppingAreaList.tmz_load_push(...json.data);
                            if (json.data.length >= pData.pageSize) {
                                self.infiniteLoadingState?.loaded();

                            } else {
                                self.infiniteLoadingState?.complete();
                            }

                            //完成
                            resolve();

                        } else {
                            //失敗
                            self.infiniteLoadingState?.complete();
                            reject('失敗');
                        }
                    }}`;
                });
            },

            /** 取得附近店家列表 */
            getStoreListWithState: function ($state) {
                let pData = this.pageData;
                let self = this;
                self.infiniteLoadingState = $state;

                return new Promise(function(resolve, reject) {
                    self.$http.fetch`StoreList${{
                        searchType: 2,    //0：熱門店家、1：最新店家、2：離我最近、3：高度評價、4： 隨機店家
                        offset: pData.currentPage,
                        lng: pData.lng,
                        lat: pData.lat,
                        searchText: pData.searchText,
                        // storeTypeId: (self.filterTab === null)? undefined: self.filterTab.id,
                        // subStoreTypeId: (self.filterTag === null)? undefined: self.filterTag.id,
                    }} ${json => {

                        if (self.$public.notNull(json.data)) {

                            pData.currentPage++;
                            pData.storeList.tmz_load_push(...json.data);
                            if (json.data.length >= pData.pageSize) {
                                self.infiniteLoadingState?.loaded();

                            } else {
                                self.infiniteLoadingState?.complete();
                            }

                            //完成
                            resolve();

                        } else {
                            //失敗
                            self.infiniteLoadingState?.complete();
                            reject('失敗');
                        }
                    }}`;
                });
            },

            /**
             * 取得可訂位可外帶的店家列表
             * searchExtension: 1：可訂候位, 2：可外帶外送
             * */
            getExtensionStoreListWithState: function ($state) {
                let pData = this.pageData;
                let self = this;
                self.infiniteLoadingState = $state;

                let searchExtension = 0;
                if (pData.tabType === constDefine.TAB_ID_TAKEOUT) {
                    searchExtension = constDefine.STORE_TAKEOUT
                } else if (pData.tabType === constDefine.TAB_ID_BOOKING) {
                    searchExtension = constDefine.STORE_BOOKING
                }

                return new Promise(function(resolve, reject) {
                    self.$http.fetch`StoreExtensionList${{
                        searchType: 2,    //0：熱門店家、1：最新店家、2：離我最近、3：高度評價、4： 隨機店家
                        offset: pData.currentPage,
                        lng: pData.lng,
                        lat: pData.lat,
                        searchExtension: searchExtension,
                        searchText: pData.searchText,
                        // storeTypeId: (self.filterTab === null)? undefined: self.filterTab.id,
                        // subStoreTypeId: (self.filterTag === null)? undefined: self.filterTag.id,
                    }} ${json => {
                        if (self.$public.notNull(json)) {
                            if (self.$public.notNull(json.data)) {
                                pData.currentPage++;

                                // pData.storeList.tmz_load_push(...json.data);
                                if (searchExtension === constDefine.STORE_TAKEOUT) {
                                    pData.storeTakeoutList.tmz_load_push(...json.data);

                                } else if (searchExtension === constDefine.STORE_BOOKING) {
                                    pData.storeBookingList.tmz_load_push(...json.data);
                                }

                                if (json.data.length >= pData.pageSize) {
                                    self.infiniteLoadingState?.loaded();       //全部載完沒資料了，才能用 complete
                                } else {
                                    self.infiniteLoadingState?.complete();
                                }

                            } else {
                                self.infiniteLoadingState?.complete();
                            }

                            //完成
                            resolve();

                        } else {
                            self.infiniteLoadingState?.complete();
                            //失敗
                            reject('失敗');
                        }

                    }}`;
                });
            },

            /** 是否顯示備註 */
            isShowRemark: function(storeInfo) {
                let result = false;
                if (this.$public.notNull(storeInfo) && this.$public.notNull(storeInfo.noteStatus) &&
                    this.$public.notNull(storeInfo.title) && this.$public.notNull(storeInfo.notes)) {
                    result = storeInfo.noteStatus &&
                        storeInfo.title !== '' &&
                        storeInfo.notes.length > 0;
                }
                return result ;
            },

            /** 備註 */
            getRemark: function(storeInfo) {
                let result = '';
                if (this.$public.notNull(storeInfo.notes) &&
                    storeInfo.notes.length > 0) {
                    storeInfo.notes.forEach(function (value) {
                        if (value !== '') {
                            result = result + '<p>'+ value ;
                        }
                    })
                }
                return result;
            },

            /**
             * 以 ID 取得分頁類別
             * */
            getStoreTypeById: function (typeId) {
                let pData = this.pageData;
                if (pData) {
                    for (let sType of pData.typeList) {
                        if (Number(typeId) === sType.id) {
                            return sType;
                        }
                    }
                }
                return null;
            },

            /** 關鍵字輸入 */
            onKeywordEnter(keyword) {
                this.pageData.searchText = keyword;
                if ( this.$public.notNull(this.pageData?.currentTab)) {
                    this.init();
                    // this.tabReset(this.pageData.currentTab);
                    this.handLoading();
                }

            },
        },
    }
</script>

<style lang="less" scoped src="../../less/complex.less"/>
